import NextImage from 'next/image';
import NextLink from 'next/link';
import React from 'react';

import { Container } from 'components/common/container';
// import Text from "components/common/Text";
import { AuthLayoutWrapper } from './styles';

type AuthLayoutProps = {
  children: React.ReactNode;
  // signUp?: boolean;
};

function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <AuthLayoutWrapper>
      <header className="auth-header">
        <Container size="lg">
          <NextLink href="/" passHref>
            <a className="auth-header-logo">
              <NextImage src="/static/logo-1.png" width={25} height={40} />
            </a>
          </NextLink>
          <NextLink href="/" passHref>
            <a className="auth-header-logo-mobile">
              <NextImage src="/static/logo-2.svg" width={105} height={25} />
            </a>
          </NextLink>

          {/*        
            <div className="auth-header-actions">
              <Text type="mode1" fw="medium">
                {signUp ? `Already have an account?` : `Don't have an account?`}
              </Text>
              <NextLink
                href={signUp ? `/auth/sign-in` : `/auth/sign-up`}
                passHref
              >
                <a className="auth-header-actions-link">
                  <Text type="mode1" fw="medium">
                    {signUp ? `Sign In` : `Sign Up`}
                  </Text>
                </a>
              </NextLink>
            </div> */}
        </Container>
      </header>
      {children}
    </AuthLayoutWrapper>
  );
}

export default AuthLayout;
